"use strict";

exports.__esModule = true;
exports.default = void 0;
var TYPE_OPTIONS = /*#__PURE__*/function (TYPE_OPTIONS) {
  TYPE_OPTIONS["BUTTON_LOADER"] = "buttonLoader";
  TYPE_OPTIONS["SEARCH_LOADER"] = "searchLoader";
  TYPE_OPTIONS["BOX_LOADER"] = "boxLoader";
  TYPE_OPTIONS["PAGE_LOADER"] = "pageLoader";
  TYPE_OPTIONS["INLINE_LOADER"] = "inlineLoader";
  return TYPE_OPTIONS;
}(TYPE_OPTIONS || {});
var _default = exports.default = TYPE_OPTIONS;